import { render, staticRenderFns } from "./TrafficTaskPage.vue?vue&type=template&id=a4e9ea0c&scoped=true&"
import script from "./TrafficTaskPage.vue?vue&type=script&lang=js&"
export * from "./TrafficTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e9ea0c",
  null
  
)

export default component.exports